import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useBazi } from '../contexts/BaziContext';

/**
 * 路由守卫组件
 * 包裹需要排盘才能访问的页面路由
 * 如果用户未排盘，自动跳转到首页并提示"请先完成排盘"
 */
export default function RouteGuard({ children }) {
  const { isBaziLoaded, isHydrated } = useBazi();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 等待 localStorage 恢复完成再判断，避免刷新后误重定向
    if (isHydrated && !isBaziLoaded) {
      const returnPath = location.pathname + location.search;
      navigate(`/input?returnTo=${encodeURIComponent(returnPath)}`, {
        state: { message: '请先完成排盘' }
      });
    }
  }, [isBaziLoaded, isHydrated, navigate, location]);

  // 恢复中：显示加载状态，不提前重定向
  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper">
        <div className="w-8 h-8 border-2 border-zhusha/20 border-t-zhusha rounded-full animate-spin" />
      </div>
    );
  }

  if (!isBaziLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-zhusha/10 flex items-center justify-center">
            <span className="text-2xl">🔒</span>
          </div>
          <p className="text-stone/70 mb-2">请先完成排盘</p>
          <p className="text-xs text-stone/40">正在为你跳转到排盘页面...</p>
        </div>
      </div>
    );
  }

  return children;
}
